import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";
import { getArticlesByCategory } from "@/mocks/articles";
import { tintMap } from "@/lib/content";

export default function CategoryGrid() {
  return (
    <section className="bg-background-50 border-b border-background-200">
      <div className="mx-auto w-full max-w-[1240px] px-4 md:px-6 py-14 md:py-20">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {categories.map((item) => {
            const tint = tintMap[item.tint];
            const count = getArticlesByCategory(item.slug).length;
            return (
              <Link
                key={item.slug}
                to={`/topic/${item.slug}`}
                className="group flex flex-col p-6 rounded-lg bg-background-100 border border-background-200 hover:border-primary-300 transition-colors"
              >
                <div className="flex items-center justify-between">
                  <span className={`w-11 h-11 flex items-center justify-center rounded-md ${tint.chipBg} ${tint.chipText}`}>
                    <i className={`${item.icon} text-xl`}></i>
                  </span>
                  <span className="text-xs text-foreground-500">{count} 篇看点</span>
                </div>
                <h3 className="mt-4 text-lg font-semibold text-foreground-950 group-hover:text-primary-700 transition-colors">
                  {item.name}
                </h3>
                <p className="mt-2 text-sm leading-relaxed text-foreground-600">{item.desc}</p>
                <span className="mt-5 inline-flex items-center gap-1.5 text-sm text-foreground-700 group-hover:gap-2.5 transition-all">
                  进入分类
                  <i className="ri-arrow-right-line"></i>
                </span>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}